import { ThemeOptions } from '@mui/material/styles';

export const typography: ThemeOptions['typography'] = {
  fontFamily: "Inter, Roboto, Helvetica, Arial, sans-serif",
  // Custom emphasis weight; MUI ships Light/Regular/Medium/Bold only.
  fontWeightSemiBold: 600,
};
